import { PropertySelector } from "../PropertySelector";
import { ShapefileBundleWizardProps, WizardStep } from "../Wizard";
import { TemplateExample } from "../TemplateExample";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FieldIcon from "portal/images/icons/field.svg?react";
import React from "react";

export const BuildFieldName: WizardStep<ShapefileBundleWizardProps> = {
  stepNameI18NKey: "views.farms.importFarms.step3BuildFieldName.stepName",
  Render: ({
    inputFeatures,
    propertyExamples,
    fieldNameTemplate,
    setFieldNameTemplate,
  }) => {
    const { t } = useTranslation();
    const firstFeature = inputFeatures[0];

    return (
      <>
        <div>
          {t("views.farms.importFarms.step3BuildFieldName.instructions")}
        </div>
        <Typography variant="h6">
          {t("views.farms.importFarms.step3BuildFieldName.exampleFieldName")}
        </Typography>
        <div>
          {firstFeature && fieldNameTemplate.length > 0 ? (
            <TemplateExample
              template={fieldNameTemplate}
              properties={firstFeature.properties}
            />
          ) : (
            <span>
              {t("views.farms.importFarms.step3BuildFieldName.noneSelected")}
            </span>
          )}
        </div>
        <PropertySelector
          Icon={FieldIcon}
          iconTooltip="Field Name"
          propertyExamples={propertyExamples}
          selectedPropertyList={fieldNameTemplate}
          updateSelectedPropertyList={setFieldNameTemplate}
        />
      </>
    );
  },
  mapSelectionEnabled: false,
  canAdvancePastStep: ({ farmNameTemplate, fieldNameTemplate }) =>
    farmNameTemplate.length > 0 && fieldNameTemplate.length > 0,
};
